module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAAXNSR0IArs4c6QAAADxQTFRFAAAAUFBQWlpaWVlZWFhYV1dXWVlZWFhYWFhYWFhYWFhYWVlZWFhYWFhYWVlZWVlZWFhYWFhYWVlZWVlZ6BNhDwAAABN0Uk5TABAwP0BPUH+An6CvsL/Az9Df4HmpEmEAAACaSURBVDjLrZPJEoQgDEQ7Gh0FxO3//9VBqjwNzeK8C5dXSSqhAdlPyi4A9MygUTJTEvNI4UmgPyRdbpRKPo7heCXnvzheicy0LknWR8rvSRx3nKCU4UMZgtPlZuoqDlx5O2gf4JKJHcx7CXqD1gPnV1C0TIwTZSy+r1jezdaEc/NJtuZw2vD77T/CGSdpDuecjsFcE86DO4fgAka2Ldh2gGpsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/saveNotar.png
// module id = meb/
// module chunks = 1